import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { change_password, get_company_process, get_company_process_stage, get_user_company, setChangePasswordOpen, setProcessTab, setStageTab, setProcessHasJobForm } from "../../../store/user/userSlice";

const mapStateToProps = (state) => {
    const {
        company_process,
        company_process_stage,
        selected_process_tab,
        selected_stage_tab,
        selected_company,
        is_open,
        company_details,
        all_jobs_count
    } = state.user;
    return {
        company_process : company_process,
        company_process_stage : company_process_stage,
        selected_process_tab : selected_process_tab,
        selected_stage_tab : selected_stage_tab,
        selected_company : selected_company,
        is_open : is_open,
        company_details : company_details,
        all_jobs_count : all_jobs_count
    };
};

const mapDispatchToProps = (dispatch) => 
    bindActionCreators(
        {
            get_company_process,
            get_company_process_stage,
            get_user_company,
            change_password,
            setChangePasswordOpen,
            setProcessTab,
            setStageTab,
            setProcessHasJobForm
        },
        dispatch
    );


const Store = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;